/**
 * Circular upload-progress indicator. The filled arc grows with `progress` (0-1).
 * Optionally renders the percentage inside the ring (only when the ring is large
 * enough for the text to be legible).
 */
export function UploadProgressRing(props: { progress: number; size?: number; strokeWidth?: number; showPercent?: boolean }) {
  const size = props.size ?? 24;
  const strokeWidth = props.strokeWidth ?? 3;
  const progress = Math.max(0, Math.min(1, props.progress));
  const r = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * r;
  const showPercent = props.showPercent ?? size >= 22;

  return (
    <span className="upload-progress-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle
          className="upload-progress-ring-track"
          cx={size / 2} cy={size / 2} r={r}
          strokeWidth={strokeWidth} fill="none"
        />
        <circle
          className="upload-progress-ring-fill"
          cx={size / 2} cy={size / 2} r={r}
          strokeWidth={strokeWidth} fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - progress)}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      {showPercent && (
        <span className="upload-progress-ring-label" style={{ fontSize: Math.max(8, Math.round(size * 0.3)) }}>{Math.round(progress * 100)}%</span>
      )}
    </span>
  );
}
